import React from 'react';
import Loadable from '@loadable/component';

import './company-mission.styles.scss';

const Slide = Loadable(() => import('react-reveal/Slide'));
const Jump = Loadable(() => import('react-reveal/Jump'));

const CompanyMission: React.FC = () => {
  return (
    <Slide left>
      <div className="about res-pt-0 pb-100 pt-70">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="about-image">
                <img
                  src={require('../../assets/photos/company-mission.png')}
                  alt="company mission"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="about-content">
                <div className="content">
                  <h2>The Hiring Of New And Talented Staff Is Affected By:</h2>
                  <ul className="content-list">
                    <Jump>
                      <li>
                        <i className="flaticon-tick"></i> Long commutes
                      </li>
                    </Jump>
                    <Jump>
                      <li>
                        <i className="flaticon-tick"></i> Limited access to the
                        workplace due to gaps in public transit
                      </li>
                    </Jump>
                  </ul>
                  <p>
                    These can often discourage applications and even affect the
                    retention of current talent.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};

export default CompanyMission;
